import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.GATSBY_MIXPANEL_TOKEN;

export const bootstrapMixpanel = () => {
    if (typeof window === "undefined") return;
    if (!MIXPANEL_TOKEN) {
        console.warn("[Mixpanel] Missing token — skipping init");
        return;
    }
    if ((window as any).__mixpanelBootstrapped__) return;

    mixpanel.init(MIXPANEL_TOKEN, {
        api_host: "https://api-eu.mixpanel.com",
        record_sessions_percent: 100,
        persistence: "cookie",      // 👈 required placeholder
        disable_persistence: true,  // 👈 this is what really disables all storage
        // debug: true,
        // autocapture: true,
    });

    (window as any).__mixpanelBootstrapped__ = true;
    console.log("[Mixpanel] Bootstrapped (anonymous mode)");
};

export const sendAnonymousVisit = () => {
  if (typeof window === "undefined") return;
  if (!MIXPANEL_TOKEN) {
    console.warn("[Mixpanel] Missing token — skipping event");
    return;
  }

  // Wait until mixpanel is fully ready
  if (!(mixpanel as any)._ || (mixpanel as any)._.disabled) {
    console.warn("[Mixpanel] Not initialized yet, delaying event");
    setTimeout(sendAnonymousVisit, 200);
    return;
  }

  try {
    mixpanel.track("anon_visit", {
      page: window.location.pathname,
      ts: new Date().toISOString(),
    });
    console.log("[Mixpanel] Anonymous visit sent");
  } catch (err) {
    console.error("[Mixpanel] Failed to send anon visit:", err);
  }
};

export const upgradeMixpanelConsentMode = () => {
  if (typeof window === "undefined") return;
  if (!MIXPANEL_TOKEN) return;

  try {
    // Mixpanel doesn't allow changing persistence on the fly,
    // so we fully re-initialize it.
    mixpanel.init(MIXPANEL_TOKEN, {
      api_host: "https://api-eu.mixpanel.com",
      record_sessions_percent: 100,
      persistence: "cookie",
      disable_persistence: false,  // 👈 enable persistence now
      // autocapture: true,
    });

    console.log("[Mixpanel] Upgraded to consent mode");
  } catch (err) {
    console.error("[Mixpanel] Failed to upgrade Mixpanel mode:", err);
  }
};

export const trackPageView = (page_path: string) => {
  if (typeof window === "undefined") return;

  try {
    mixpanel.track("page_view", {
      page_path,
      page_location: window.location.href,
      referrer: document.referrer || null,
      ts: new Date().toISOString(),
    });
  } catch (err) {
    console.error("[Mixpanel] Failed to track page_view:", err);
  }
};

export const trackSectionView = (section: string, source: string) => {
  if (typeof window === "undefined") return;

  try {
    mixpanel.track("section_view", {
      section,
      source,  // same naming you use in GA (e.g. "link", "direct")
      page_path: window.location.pathname + window.location.search,
      page_location: window.location.href,
      ts: new Date().toISOString(),
    });
    console.log("[Mixpanel] section_view:", section, source);
  } catch (err) {
    console.error("[Mixpanel] Failed to track section_view:", err);
  }
};

export const trackLinkClick = (href: string, label?: string) => {
  try {
    mixpanel.track("link_click", {
      href,
      label: label || href,
      page: window.location.pathname,
      ts: new Date().toISOString(),
    });
    console.log("[Mixpanel] link_click →", href);
  } catch (err) {
    console.error("[Mixpanel] Failed to track link click:", err);
  }
};

export const trackClick = (element: string, extra?: Record<string, any>) => {
  try {
    mixpanel.track("click", {
      element,
      ...extra,
      page: window.location.pathname,
      ts: new Date().toISOString(),
    });
    console.log("[Mixpanel] click →", element);
  } catch (err) {
    console.error("[Mixpanel] Failed to track click:", err);
  }
};